/**
 * Plain, and serious.
 *
 * Failure states come from the API envelope, not from a guess about what went
 * wrong: the server rate-limits by account and says so, and inventing "wrong
 * username or password" over the top of a lock-out message leaves an officer
 * retrying a password that is correct.
 */

import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '../api/client'
import { ErrorEnvelope } from '../components/bits'
import { safeNext } from '../lib/session'

export function Login() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const next = safeNext(params.get('next'))

  const signIn = useMutation({
    mutationFn: () => api.login(username, password),
    onSuccess: (user) => {
      queryClient.setQueryData(['me'], user)
      navigate(next, { replace: true })
    },
  })

  return (
    <div className="login">
      <div className="login-panel">
        <div className="org">
          {/* Pre-authentication, nobody's factory is known — one deployment
              now serves all nine, so the masthead is the organisation's. The
              25 Aug 2026 ruling wanted the login screen to say where you are;
              where-you-are became a fact about the signed-in officer, and the
              shell names their factory the moment they are known. */}
          <div className="main">AWEIL — Disciplinary Section</div>
          <div className="sub">Advanced Weapons and Equipment India Limited</div>
        </div>
        <div className="card">
          <div className="body">
            <form
              onSubmit={(event) => {
                event.preventDefault()
                signIn.mutate()
              }}
            >
              {signIn.error ? <ErrorEnvelope error={signIn.error} /> : null}
              <div className="field">
                <label htmlFor="username">Username</label>
                <input
                  id="username"
                  name="username"
                  autoComplete="username"
                  autoFocus
                  value={username}
                  onChange={(event) => setUsername(event.target.value)}
                />
              </div>
              <div className="field">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
              </div>
              <button
                type="submit"
                className="primary"
                style={{ width: '100%' }}
                disabled={signIn.isPending || !username || !password}
              >
                {signIn.isPending ? 'Signing in…' : 'Sign in'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
